function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';

var AmountField = /*#__PURE__*/function (_React$Component) {
  _inherits(AmountField, _React$Component);

  var _super = _createSuper(AmountField);

  function AmountField() {
    _classCallCheck(this, AmountField);

    return _super.apply(this, arguments);
  }

  _createClass(AmountField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onWholeAmountChange = _this$props.onWholeAmountChange,
          onDecimalAmountChange = _this$props.onDecimalAmountChange,
          wholeAmountValue = _this$props.wholeAmountValue,
          decimalAmountValue = _this$props.decimalAmountValue,
          exponent = _this$props.exponent,
          decimalFieldError = _this$props.decimalFieldError,
          remainingAmountRadioChange = _this$props.remainingAmountRadioChange,
          remainingAmountOption = _this$props.remainingAmountOption,
          supportsRemainingAmount = _this$props.supportsRemainingAmount,
          customAmountOption = _this$props.customAmountOption,
          splitPaymentTrx = _this$props.splitPaymentTrx,
          terminalCurrency = _this$props.terminalCurrency,
          managedRecurring = _this$props.managedRecurring,
          disabled = _this$props.disabled,
          terminalSelected = _this$props.terminalSelected,
          withRequiredReferenceId = _this$props.withRequiredReferenceId,
          showRemainingAmountOptions = _this$props.showRemainingAmountOptions;
      var managedRecurringPrefix = managedRecurring ? 'managed_recurring_' : '';
      var remainingOptionsVisible = showRemainingAmountOptions(terminalSelected, splitPaymentTrx, withRequiredReferenceId);
      return React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement("div", {
        className: "input-group"
      }, React.createElement("input", {
        type: "text",
        name: "".concat(managedRecurringPrefix, "whole_amount"),
        id: "".concat(managedRecurringPrefix, "whole_amount"),
        value: wholeAmountValue,
        onChange: onWholeAmountChange,
        className: "form-control text-right",
        min: "0",
        disabled: disabled
      }), React.createElement("div", {
        className: "input-group-addon"
      }, ","), React.createElement("input", {
        type: "text",
        name: "".concat(managedRecurringPrefix, "decimal_amount"),
        id: "".concat(managedRecurringPrefix, "decimal_amount"),
        value: decimalAmountValue,
        size: "2",
        maxLength: exponent,
        className: "form-control",
        onChange: onDecimalAmountChange,
        disabled: disabled
      }), React.createElement("div", {
        className: "input-group-addon"
      }, React.createElement("span", {
        id: "".concat(managedRecurringPrefix, "valid_amount")
      }, React.createElement("i", {
        className: "".concat(decimalFieldError ? 'glyphicon glyphicon-remove text-danger' : 'glyphicon glyphicon-ok text-success')
      })), React.createElement("span", {
        className: "".concat(terminalCurrency ? 'currency ml-5' : 'currency')
      }, terminalCurrency))), supportsRemainingAmount && React.createElement("div", {
        id: "remaining-options",
        className: "form-group ".concat(remainingOptionsVisible ? '' : 'hidden')
      }, React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement("div", {
        className: "input-group"
      }, React.createElement("label", {
        className: "radio-inline",
        htmlFor: "input_amount_remaining"
      }, React.createElement("input", {
        type: "radio",
        name: "input_amount",
        id: "input_amount_remaining",
        value: remainingAmountOption,
        className: "input_amount_radio",
        onChange: remainingAmountRadioChange
      }), "Remaining Value", React.createElement("span", {
        id: "remaining_amount_value"
      }, " (-.--)")), React.createElement("label", {
        className: "radio-inline",
        htmlFor: "input_amount_custom"
      }, React.createElement("input", {
        type: "radio",
        name: "input_amount",
        id: "input_amount_custom",
        value: customAmountOption,
        className: "input_amount_radio",
        onChange: remainingAmountRadioChange
      }), "Custom Value"))))));
    }
  }]);

  return AmountField;
}(React.Component);

export default AmountField;